import styled from 'styled-components';
import { Text } from '@rsos/components/capstone/base';
import { BasePrimaryText } from '../common.styles';

export const AssignDropdownBasePrimaryText = styled(BasePrimaryText)`
  word-break: break-word;
`;
export const AssignDropdownBaseSecondaryText = styled(Text).attrs({
  size: 'normal',
  color: 'secondaryText',
})`
  word-break: break-word;
`;
